import { apiGet, apiPost } from 'APIPackage/MainModule/common/apiTools';
import { SmevMonitoringColumnTypeEnum } from 'SmevMonitoringPackage/MainModule/enums/SmevMonitoringColumnType';

import { ISmevMonitoringChart } from '../interfaces/ISmevMonitoringChart';
import { ISmevMonitoringFilterIndex } from '../interfaces/ISmevMonitoringFilterIndex';
import { ISmevMonitoringIndex } from '../interfaces/ISmevMonitoringIndex';
import { ISmevMonitoringIndexPage } from '../interfaces/ISmevMonitoringIndexPage';

export async function fetchSmevMonitoringFindIndex(
  page: number,
  size: number,
  filter: ISmevMonitoringFilterIndex | null,
  order?: string,
): Promise<ISmevMonitoringIndexPage> {
  const params = new URLSearchParams();

  params.append('page', String(page));
  params.append('size', String(size));
  if (order) {
    params.append('order', order);
  }

  return apiPost<ISmevMonitoringIndexPage>({ url: `/smev-monitoring/api/find?${params}`, body: filter || {} });
}

export async function fetchSmevMonitoringSystemTypes(): Promise<string[]> {
  return apiGet<string[]>('/smev-monitoring/api/systems');
}

export async function fetchSmevMonitoringMessageTypes(): Promise<string[]> {
  return apiGet<string[]>('/smev-monitoring/api/message-types');
}

export async function fetchSmevMonitoringSmevMessageTypes(): Promise<string[]> {
  return apiGet<string[]>('/smev-monitoring/api/smev-message-types');
}

export async function fetchSmevMonitoringServiceTypes(systemType: string): Promise<string[]> {
  const params = new URLSearchParams();

  params.append('system', systemType);

  return apiGet<string[]>(`/smev-monitoring/api/services?${params}`);
}

export async function fetchSmevMonitoringEndpoints(): Promise<string[]> {
  return apiGet<string[]>('/smev-monitoring/api/endpoints');
}

export async function fetchSmevMonitoringProcessingStatuses(): Promise<string[]> {
  return apiGet<string[]>('/smev-monitoring/api/processing-statuses');
}

export async function fetchSmevMonitoringSendingStatuses(): Promise<string[]> {
  return apiGet<string[]>('/smev-monitoring/api/sending-statuses');
}

export async function fetchSmevMonitoringCharts(
  systemType?: string,
  serviceType?: string,
  endpoint?: string,
): Promise<ISmevMonitoringChart[]> {
  const params = new URLSearchParams();

  systemType && params.append('system', systemType);
  serviceType && params.append('service', serviceType);
  endpoint && params.append('endpoint', endpoint);

  return apiGet<ISmevMonitoringChart[]>(`/smev-monitoring/api/charts?${params}`);
}

export async function fetchSmevMonitoringMessageById(id: number): Promise<ISmevMonitoringIndex> {
  return apiGet<ISmevMonitoringIndex>(`/smev-monitoring/api/${id}`);
}

export async function fetchSmevMonitoringDownloadMessage(
  id: number,
  column: SmevMonitoringColumnTypeEnum,
): Promise<Blob> {
  const params = new URLSearchParams();

  params.append('column', column);

  return apiGet<Blob>(`/smev-monitoring/api/download/${id}?${params}`);
}

export async function fetchSmevMonitoringSenders(): Promise<string[]> {
  return apiGet<string[]>('/smev-monitoring/api/senders');
}
